/** Read a single displayed package amount; quotes/ranges are intentionally not guessed. */
export function packagePrice(label: string): { amountMinor: number; currency: string } | null {
  const raw = label
    .trim()
    .replace(/[\u00a0\u202f]/g, ' ')
    .replace(/^(?:from|starting (?:at|from))\s+/i, '');
  const match = /^(?:(€|EUR|\$|USD|£|GBP)\s*)?(\d[\d .,]*)(?:\s*(€|EUR|\$|USD|£|GBP))?$/i.exec(raw);
  if (!match) return null;
  const currency = (value: string) =>
    (({ '€': 'EUR', $: 'USD', '£': 'GBP' }) as Record<string, string>)[value] ??
    value.toUpperCase();
  if (match[1] && match[3] && currency(match[1]) !== currency(match[3])) return null;
  const value = match[2]!.trim();
  const decimal = /[.,](\d{1,2})$/.exec(value);
  const whole = decimal ? value.slice(0, decimal.index) : value;
  if (!/^\d+$/.test(whole) && !/^\d{1,3}([ .,])\d{3}(?:\1\d{3})*$/.test(whole)) return null;
  const amountMinor =
    Number(whole.replace(/[ .,]/g, '')) * 100 + Number((decimal?.[1] ?? '').padEnd(2, '0'));
  if (!Number.isSafeInteger(amountMinor) || amountMinor > 2147483647) return null;
  return { amountMinor, currency: currency(match[1] ?? match[3] ?? 'EUR') };
}
